import './index.css'

const ContactSection = () => (
  <div className="contact-section">
    <h1>My Contact</h1>
    <p>
      If you like my works and my way of approach towards things, do feel free
      to contact me. Thank you!
    </p>
    <h3 className="contact-title">Contact details:</h3>
    <p>+91 9845678900</p>
    <p>prathyushsunny@gmail.com</p>
  </div>
)

export default ContactSection
